import {
  AttachmentControllerRoute,
  AttachmentControllerRouteToMetadataTypesMap,
} from ".."
import { createContext } from "react"
import { DefaultError } from "@components/error-context"

export type TAttachmentUploadQueueItemStatus =
  "pending" | "uploading" | "completed" | "failed" | "canceled"

export interface IAttachmentUploadQueueItem<
  ControllerRoute extends AttachmentControllerRoute,
> {
  guid: string
  file: File
  progress: number
  status: TAttachmentUploadQueueItemStatus
  attachmentControllerRoute: ControllerRoute
  containerId: number | undefined
  metadata?: (typeof AttachmentControllerRouteToMetadataTypesMap)[ControllerRoute]["partialMetadata"]
  handlers?: {
    onSuccess?: (
      metadata: (typeof AttachmentControllerRouteToMetadataTypesMap)[ControllerRoute]["metadata"]
    ) => void
    onComplete?: () => void
    onError?: (error: DefaultError) => void
  }
}

interface AttachmentUploadContext {
  addToUploadQueue: <Route extends AttachmentControllerRoute>(
    files: File[],
    attachmentControllerRoute: Route,
    containerId: number | undefined,
    attachmentMetadata?: (typeof AttachmentControllerRouteToMetadataTypesMap)[Route]["partialMetadata"],
    handlers?: {
      onSuccess?: (
        metadata: (typeof AttachmentControllerRouteToMetadataTypesMap)[Route]["metadata"]
      ) => void
      onComplete?: () => void
      onError?: (error: DefaultError) => void
    }
  ) => void

  cancelUpload: (guid: string) => void

  uploadQueue: IAttachmentUploadQueueItem<AttachmentControllerRoute>[]

  currentUpload:
    IAttachmentUploadQueueItem<AttachmentControllerRoute> | undefined

  uploadHistory: IAttachmentUploadQueueItem<AttachmentControllerRoute>[]
}

export const AttachmentUploadContext = createContext<AttachmentUploadContext>({
  addToUploadQueue: () => {},
  cancelUpload: () => {},
  uploadQueue: [],
  currentUpload: undefined,
  uploadHistory: [],
})
